import { WorkoutMode } from 'app/@core/backend/common/services/CalorieFriend/workout.service';
import { WorkoutService } from './../../../../../@core/backend/common/services/CalorieFriend/workout.service';
import { FitnessPlanDay } from 'app/@core/interfaces/common/CalorieFriend/plan-day';
import { FitnessPlan } from './../../../../../@core/interfaces/common/CalorieFriend/plan';
import { NbDialogService } from '@nebular/theme';
import * as DateFns from 'date-fns';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs';
import { ConfirmMessageDialogComponent } from 'app/@components/confirm-message-dialog/confirm-message-dialog.component';
import {
  zoomInAnimation,
  zoomInOnEnterAnimation,
} from 'app/@core/utils/animation';
import { WorkoutTimerService } from 'app/@core/backend/common/services/CalorieFriend/workout-timmer.service';
import { Workout, WorkoutStatus } from 'app/@core/interfaces/common/CalorieFriend/workout';

const getTimeString = (second, { showHour = true } = {}) => {
  let h = Math.floor(second / 3600);
  let m = showHour ? Math.floor((second % 3600) / 60) : Math.floor(second / 60);
  let s = second % 60;
  let vals = showHour ? [h, m, s] : [m, s];
  return vals.map((t) => ('0' + t).slice(-2)).join(':');
};

@Component({
  selector: 'app-fitness-workout-overlay',
  templateUrl: './fitness-workout-overlay.component.html',
  styleUrls: ['../fitness-workout.component.scss'],
  animations: [zoomInOnEnterAnimation({ delay: 100, duration: 800 })],
})
export class FitnessWorkoutOverlayComponent implements OnInit {
  counter: number = null;
  timer: number = 0;
  timerString: string = '00:00:00';
  _timerTimeout: any;

  restTimer: number = 0;
  restTimerString: string = '00:00';
  _restTimerTimout: any;
  workoutTimerModeSubscription: Subscription;

  startDatetime: Date;
  lastDateTime: Date;

  @Input('currentExercise')
  currentExercise: string = '';

  @Output('onPause')
  onPauseEvent = new EventEmitter<any>();

  @Output('onStopWorkout')
  onStopWorkoutEvent = new EventEmitter<any>();

  /**
   * @description
   * Rest if greater than 0
   * No rest if equal to 0
   * Don't show rest if less than 0
   */
  @Input('restTime')
  totalRestTime: number = -1;
  public workoutMode: WorkoutMode;
  private workout: Workout;

  constructor(
    private workoutService: WorkoutService,
    private dialogService: NbDialogService,
    private workoutTimerService: WorkoutTimerService,
  ) { }

  // public workoutMode() {
  //   return this.workoutService.workoutMode.value;
  // }
  readonly WorkoutMode = WorkoutMode;

  ngOnInit(): void {
    this.workoutTimerService.workoutTime.subscribe(res => {
      this.timer = res;
      this.timerString = this.workoutTimerService.formatTime(res);
    });
    this.workoutTimerModeSubscription = this.workoutTimerService.workoutMode.subscribe(res => {
      this.workoutMode = res;
    });
    this.workoutService.workout.subscribe(workout => {
      this.workout = workout;
    });
    if (this.totalRestTime > 0) {
      this.startRest();
    } else {
      setTimeout(() => {
        this.restTimer = 0;
        this.counter = -1;
        this.workoutMode = this.workoutTimerService.workoutMode.value;
        if(this.workoutMode != WorkoutMode.Workout) this.startTimer();
      }, 1200);
    }

  }
  /**
   * @description Start Rest
   */
  startRest() {
    this.restTimer = this.totalRestTime;
    this.restTimerString = getTimeString(this.restTimer, { showHour: false });

    this._restTimerTimout = setInterval(() => {
      if (this.restTimer <= 0) {
        clearInterval(this._restTimerTimout);
        this.startCounter();
        return;
      }
      this.restTimer--;
      this.restTimerString = getTimeString(this.restTimer, { showHour: false });
    }, 1000);
  }
  /**
   * @description Skip Rest
   */
  skipRest() {
    clearInterval(this._restTimerTimout);
    this.startCounter();
  }
  /**
   * @description Start counting animation.
   */
  startCounter() {
    this.restTimer = 0;
    this.counter = -1;
    this.workoutTimerService.reset();
    this.startTimer();
  }
  /**
   * @description Stop workout
   */
  onStopWorkout() {
    this.workoutTimerService.reset();
    this.onStopWorkoutEvent.emit();
  }

  timeStartStop() {
    if(this.workoutMode === WorkoutMode.Pause) {
      this.workoutTimerService.resume();

    } else if (this.workoutMode === WorkoutMode.Workout) {
      this.pause();
    }
    return;
  }
  /**
   * @description Pause workout
   */
  pauseWorkout() {
    if (this.counter >= 0) return;
    this.onPauseEvent.emit();
    /**
     * it's not necessary
     */
    this.pause();
    clearInterval(this._timerTimeout);
  }

  /**
   * @description Resume workout
   */
  resumeWorkout() {
    if (this.workoutService.workout.value != null) {
      this.workoutService.startWorkout();
      this.startTimer();
    }
  }



  /**
   * start Timer
   */
  // startTimer(resume: boolean = false) {
  //   if (!resume) {
  //     this.startDatetime = new Date();
  //     this.lastDateTime = new Date();
      // this.workoutTimerService.reset();
      // this.workoutTimerService.resume();
  //   } else {
  //     this.startDatetime = new Date();
  //     this.lastDateTime = new Date();
  //     this.workoutTimerService.pause();
  //     this.lastDateTime.setSeconds(this.lastDateTime.getSeconds() + this.timer);
  //   }
  // }
  startTimer(){
    if(this.workoutMode == WorkoutMode.Start) {
      this.workoutTimerService.reset();
      this.workoutTimerService.start();
    } else {
      if(this.workoutMode == WorkoutMode.Pause) {
        this.workoutTimerService.resume();
      } else {
        this.pause();
      }
    }
  }
  pause(){
    let defaultWorkout: Workout;
    if(this.workout){
      defaultWorkout = {
      id: this.workout.id,
      planId: this.workout.planId,
      dayId: this.workout.dayId,
      patientId: this.workout.patientId,
      status: WorkoutStatus.Started,
      startDateTime: new Date(),
      endDateTime: new Date(),
    };
  }
    this.workoutService.pauseWorkout(defaultWorkout);
  }
}
